 <app-modal [showModal]="true">
    <div class="model-cover terms">
      <div class="model-box-loginModal">
        <div class="modal-header-loginModal"></div>
          <div class="corner-button">
            <button class="close" aria-label="Close" (click)="closeOverviewModal()">x</button>
          </div>
          <h4>Select your AT&T Business Console service below to log in.</h4>
          <div class="loginModal">
            <p><a href="javascript:void(0)" class="btn btn-secondary" (click)="loginDirect('sapmp')" aria-label="Premier">Premier</a></p>
            <p><a href="javascript:void(0)" class="btn btn-secondary" (click)="loginDirect('fnabc')" aria-label="FirstNet Central">FirstNet Central</a></p>
            <p><a href="javascript:void(0)" class="btn btn-secondary" (click)="loginDirect('myatt')" aria-label="myAT&T for Business">myAT&T for Business</a></p>
          </div> 
      </div>
    </div>
  </app-modal>
  